export default function reducer(state = {}, action) {
    return state;
}

export const NAME = 'forgotPassword';
